import { ExternalLink, Landmark, Globe2 } from "lucide-react";

const fmt = (n) => (n >= 1000000 && n % 100000 === 0 ? `${(n / 1000000).toFixed(n % 1000000 === 0 ? 0 : 1)} million` : Number(n).toLocaleString());
const day = (iso) => new Date(`${iso}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });

const Tile = ({ f }) => (
  <div className="rounded-xl border border-border bg-white/70 p-4" data-testid={`conflict-figure-${f.key}`}>
    <p className="text-xs font-medium text-slate-500">{f.label}</p>
    <p className="mt-1 font-serif text-3xl text-slate-900">{fmt(f.value)}</p>
    <p className="mt-1 text-xs text-slate-600">{f.note}</p>
    <p className="mt-2 text-[11px] text-slate-500">As of {day(f.as_of)} · <a href={f.url} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-0.5 font-medium text-[hsl(var(--facts))] hover:underline">{f.org}<ExternalLink size={10} /></a></p>
  </div>
);

const Group = ({ title, icon: Icon, rows, testid }) => !rows.length ? null : (
  <div className="space-y-2" data-testid={testid}>
    <p className="flex items-center gap-1.5 text-xs font-semibold uppercase tracking-wider text-slate-500"><Icon size={14} />{title}</p>
    <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">{rows.map((f) => <Tile key={f.key} f={f} />)}</div>
  </div>
);

export const ConflictFigures = ({ data, note }) => (
  <section className="surface space-y-5 p-5 sm:p-6" data-testid="conflict-figures">
    <div><h2 className="text-2xl">Deaths, injuries and displacement</h2>
      <p className="mt-2 rounded-lg bg-amber-50 p-3 text-sm text-amber-900" data-testid="conflict-qualifier">{data.qualifier}</p></div>
    <Group title="United Nations figures" icon={Globe2} rows={data.rows.filter((f) => f.group === "un")} testid="conflict-group-un" />
    <Group title="Government figures (claims by parties to the conflict)" icon={Landmark} rows={data.rows.filter((f) => f.group === "gov")} testid="conflict-group-gov" />
    {note && <p className="text-xs text-slate-500" data-testid="conflict-note">{note}</p>}
    <p className="text-[11px] text-slate-400">Checked weekly against the sources. A figure only changes when the source itself publishes a newer number.</p>
  </section>
);
